import snakecaseKeys from 'snakecase-keys';

import { API_METHODS, callReverseApi } from 'api/apiService';
import endpoints from 'api/CompeonReverseApi/endpoints';

export const getUserDataAction = () =>
  callReverseApi({
    url: endpoints.OP_USERS.PROFILE.compose(),
    method: API_METHODS.GET,
  });

export const saveUserDataAction = (formData: any) =>
  callReverseApi({
    url: endpoints.OP_USERS.LIST.compose(),
    method: API_METHODS.PATCH,
    data: {
      data: {
        attributes: snakecaseKeys(formData),
      },
    },
  });
